import { render, staticRenderFns } from "./finish-reg.vue?vue&type=template&id=0a4f7d1b&scoped=true&"
import script from "./finish-reg.vue?vue&type=script&lang=js&"
export * from "./finish-reg.vue?vue&type=script&lang=js&"
import style0 from "./finish-reg.vue?vue&type=style&index=0&id=0a4f7d1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f7d1b",
  null
  
)

export default component.exports